export default {
    state: {
        notification: null,
    },
    getters: {
        getNotification(state) {
            return state.notification;
        },
    },
    mutations: {
        setNotification(state, payload) {
            state.notification = payload;
        },
    },
    actions: {
        showNotification({ commit }, payload) {
            commit('setNotification', payload);
            setTimeout(() => {
                commit('setNotification', null);
            }, 4000);
        },
    },
};
